module.exports = __webpack_public_path__ + "img/4941d7c.jpg";